"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaInput = void 0;
var react_1 = require("@chakra-ui/react");
var React = __importStar(require("react"));
var MediaLibrary_1 = require("../MediaLibrary");
var MediaContext_1 = require("../MediaContext");
var Icon_1 = require("../../Icon");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var MediaMenu_1 = require("../MediaMenu");
var mediaIcons = {
    comment_media: pro_regular_svg_icons_1.faCamera,
    custom_bullet_image: pro_regular_svg_icons_1.faCamera,
    guide_main_image: pro_regular_svg_icons_1.faCamera,
    guide_step_image: pro_regular_svg_icons_1.faCamera,
    guide_step_object: pro_regular_svg_icons_1.faVideo,
    guide_step_video: pro_regular_svg_icons_1.faVideo,
    guide_step_embed: pro_regular_svg_icons_1.faVideo,
    guide_document: pro_regular_svg_icons_1.faFile,
    profile_image: pro_regular_svg_icons_1.faCamera,
    wiki_summary_image: pro_regular_svg_icons_1.faCamera,
    site_image: pro_regular_svg_icons_1.faCamera,
    wiki_media: pro_regular_svg_icons_1.faFile,
    work_order_document: pro_regular_svg_icons_1.faFile,
    work_order_image: pro_regular_svg_icons_1.faCamera,
    work_order_object: pro_regular_svg_icons_1.faVideo,
};
var Loading = 'loading';
var DEFAULT_WIDTH = 300;
var DEFAULT_HEIGHT = 300;
var ICON_SCALE_FACTOR = 2.5;
exports.MediaInput = (0, MediaContext_1.createMediaContextProvider)(function (_a) {
    var value = _a.value, onChange = _a.onChange, _js = _a._js, toast = _a.toast, props = __rest(_a, ["value", "onChange", "_js", "toast"]);
    var modal = (0, react_1.useDisclosure)();
    var mediaContext = (0, MediaContext_1.useMediaContext)();
    var _b = React.useState(false), isHovered = _b[0], setIsHovered = _b[1];
    var _c = React.useState(value ? Loading : null), mediaItem = _c[0], setMediaItem = _c[1];
    var icon = mediaContext.filter ? mediaIcons[mediaContext.filter] : pro_regular_svg_icons_1.faFile;
    function loadMediaItem(value) {
        return __awaiter(this, void 0, void 0, function () {
            var mediaItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mediaContext.loadMediaItem(value.type, value.id)];
                    case 1:
                        mediaItem = _a.sent();
                        setMediaItem(mediaItem);
                        return [2 /*return*/];
                }
            });
        });
    }
    React.useEffect(function () {
        if (value)
            loadMediaItem(value);
    }, [value === null || value === void 0 ? void 0 : value.id, value === null || value === void 0 ? void 0 : value.type]);
    function handleMediaItemSelected(mediaItem) {
        modal.onClose();
        if (onChange) {
            onChange({
                type: mediaItem.type,
                id: mediaContext.getMediaItemId(mediaItem),
            });
        }
    }
    function handleImageUploadStart() {
        setMediaItem(Loading);
    }
    function handleImageEditUploadComplete(mediaItem) {
        if (!modal.isOpen && onChange) {
            onChange({
                type: mediaItem.type,
                id: mediaContext.getMediaItemId(mediaItem),
            });
        }
    }
    function resetInput() {
        modal.onClose();
        mediaContext.setView('list');
        if (value)
            loadMediaItem(value);
    }
    var showSkeleton = mediaItem === Loading || mediaContext.view === 'crop' || mediaContext.view === 'markup';
    var border = {};
    if (!value) {
        border = {
            borderStyle: 'dashed',
            borderWidth: 2,
            borderColor: 'inherit',
            borderRadius: 8,
        };
    }
    var filteredProps = __assign(__assign({}, props), { strategy: undefined, siteName: undefined });
    delete filteredProps.strategy;
    delete filteredProps.siteName;
    var componentRef = React.useRef(null);
    var _d = React.useState({
        width: DEFAULT_WIDTH,
        height: DEFAULT_HEIGHT,
    }), dimensions = _d[0], setDimensions = _d[1];
    React.useEffect(function () {
        var updateDimensions = function () {
            if (componentRef.current) {
                var _a = componentRef.current.getBoundingClientRect(), width = _a.width, height = _a.height;
                setDimensions({ width: width, height: height });
            }
        };
        updateDimensions();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(react_1.Flex, __assign({ ref: componentRef, role: "button", "aria-label": _js('Choose file'), height: DEFAULT_HEIGHT, width: DEFAULT_WIDTH, justifyContent: "center", alignItems: "center", cursor: "pointer", onMouseOver: function () { return setIsHovered(true); }, onMouseOut: function () { return setIsHovered(false); }, backgroundColor: isHovered && !value ? 'green.200' : undefined, transition: "background-color .5s", onClick: modal.onOpen }, border, filteredProps),
            !value && (React.createElement(Icon_1.Icon, { type: icon, fontSize: getIconFontSize(dimensions.width, dimensions.height), color: "blueGray.600" })),
            value && (React.createElement(react_1.Skeleton, { isLoaded: !showSkeleton, h: "100%", w: "100%", position: "relative" },
                React.createElement(react_1.Image
                // Setting the crossOrigin would only be necessary if the image src is from a
                // a different domain. Adding it here in case our image urls are different in xprem.
                , { 
                    // Setting the crossOrigin would only be necessary if the image src is from a
                    // a different domain. Adding it here in case our image urls are different in xprem.
                    crossOrigin: "anonymous", src: mediaItem && mediaItem !== Loading ? mediaItem.standard : undefined, alt: mediaItem && mediaItem !== Loading ? mediaItem.filename : _js('image'), h: "100%", w: "100%", objectFit: "contain", position: "absolute", left: 0, opacity: isHovered ? 0.5 : 1, transition: "opacity .5s" }),
                React.createElement(react_1.Flex, { h: "100%", w: "100%", alignItems: "center", justifyContent: "center", onClick: function (e) { return e.stopPropagation(); }, zIndex: 2 },
                    React.createElement(Icon_1.Icon, { type: pro_regular_svg_icons_1.faReply, fontSize: getIconFontSize(dimensions.width, dimensions.height), color: "blueGray.600", pointerEvents: "none", display: isHovered ? undefined : 'none' }),
                    mediaItem && mediaItem !== Loading && isHovered && (React.createElement(MediaMenu_1.MediaMenu, { mediaItem: mediaItem, onDelete: function () { return onChange === null || onChange === void 0 ? void 0 : onChange(null); }, position: "absolute", bottom: 2, right: 2 })))))),
        React.createElement(MediaLibrary_1.MediaLibraryModal, { isOpen: modal.isOpen || mediaContext.view === 'crop' || mediaContext.view === 'markup', onClose: resetInput, onSelect: handleMediaItemSelected, onImageEditUploadStart: handleImageUploadStart, onImageEditUploadComplete: handleImageEditUploadComplete })));
    function getIconFontSize(width, height) {
        return Math.min(width, height) / ICON_SCALE_FACTOR;
    }
});
